module.exports = "/_next/static/images/de70deb66ee595b45123630b5c64eb64-credit-card-limit@2x.png";